import React from 'react';
import { localize } from '@guuru/translation-common';
import { useLocation } from 'react-router-dom';
import ChatRenderText from '../Text';

interface ChatRenderPartnersProps {
  message: React.ComponentProps<typeof ChatRenderText>['message'] & {
    metadata: {
      partners: {
        id: string;
        name: string;
        settings: {
          appearance: {
            chatWidgetPhotoUrl: string;
          }
        }
      }[];
    };
  };
}

const ChatRenderPartners = function ({ message }: ChatRenderPartnersProps) {
  const { search } = useLocation();

  const { partners } = message.metadata;

  if (!partners.length) {
    return (
      <ChatRenderText
        message={{ ...message, i18n: 'Partner not found' }}
        tooltip={false}
      />
    );
  }

  const getChatUrl = (partnerId: string) => (`/${partnerId}${search}`);

  return (
    <ChatRenderText message={message} tooltip={false}>
      <div className="message-partners">
        <ul className="message-partners-list">
          {partners.map((partner) => (
            <li key={partner.id} className="message-partners-list-item">
              <a
                className="message-partners-list-item-anchor"
                href={getChatUrl(partner.id)}
              >
                <img
                  className="message-partners-list-item-logo"
                  src={partner?.settings?.appearance?.chatWidgetPhotoUrl}
                  alt="partner logo"
                />
                <span className="message-partners-list-item-name">
                  {localize(partner?.name)}
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </ChatRenderText>
  );
};

export default ChatRenderPartners;
